module.exports = __webpack_public_path__ + "static/media/Liberian-Registry-logo.7e3bf9b1.png";